import React from "react";

export const AppearanceDescription = ({ children = [] }: any) => {
    return (
        <div className="mb-2">
            <small>{children}</small>
        </div>
    );
};
